export default __webpack_public_path__ + "static/media/twelve.81c564fe.jpeg";